import { defineRecipe } from '@plurall/elo-v3';

// Mirrors inputSearchNativeFieldWrapperRecipe (variant=primary, status=neutral)
export const timeInputWrapperRecipe = defineRecipe({
  className: 'time-input-wrapper',
  base: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '2.5rem',
    boxSizing: 'border-box',
    cursor: 'text',
    borderRadius: 'border.radius.small',
    borderWidth: 'border.width.medium',
    borderBottomWidth: 'border.width.xlarge',
    borderStyle: 'solid',
    borderColor: 'border.primary',
    '&:hover': { borderColor: 'action.hover.standard' },
    '&:focus-within': { borderColor: 'action.selected.standard' },
    '&:has(.focus-visible)': {
      outlineWidth: '{borderWidths.border.width.large}',
      outlineStyle: 'solid',
      outlineColor: 'action.focus.ring.primary',
      outlineOffset: '{borderWidths.border.width.large}',
    },
  },
});

// Mirrors inputSearchNativeInputRecipe (variant=embedded)
export const timeInputFieldRecipe = defineRecipe({
  className: 'time-input-field',
  base: {
    pr: '0',
    py: '1',
    border: 'none',
    background: 'transparent',
    flex: '1',
    minWidth: '0',
    height: '100%',
    textStyle: 'body.medium',
    color: 'text.primary',
    _focusVisible: { outline: 'none' },
    _disabled: { backgroundColor: 'transparent', borderColor: 'transparent' },
  },
});

// Mirrors inputSearchNativeEndContainerRecipe
export const timeInputEndContainerRecipe = defineRecipe({
  className: 'time-input-end-container',
  base: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: '0',
    paddingRight: 'padding.xsmall',
    gap: 'gap.4xsmall',
  },
});

// Mirrors inputSearchNativeIconButtonRecipe
export const timeInputTriggerRecipe = defineRecipe({
  className: 'time-input-trigger',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0',
    padding: '0',
    margin: '0',
    border: 'none',
    borderRadius: 'border.radius.3xsmall',
    background: 'transparent',
    color: 'foreground.tertiary',
    cursor: 'pointer',
    transition: 'background-color 0.14s ease',
    _disabled: { cursor: 'not-allowed', opacity: 0.5 },
  },
});

export const timeInputDropdownRecipe = defineRecipe({
  className: 'time-input-dropdown',
  base: {
    backgroundColor: 'background.primary',
    borderRadius: 'border.radius.medium',
    borderWidth: 'border.width.medium',
    borderStyle: 'solid',
    borderColor: 'border.secondary',
    paddingBlock: 'padding.2xsmall',
    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    minWidth: '12rem',
    zIndex: 1400,
  },
});

export const timeSlotItemRecipe = defineRecipe({
  className: 'time-slot-item',
  base: {
    paddingInline: 'padding.medium',
    paddingBlock: 'padding.xsmall',
    textStyle: 'body.medium',
    color: 'text.primary',
    cursor: 'pointer',
    userSelect: 'none',
    _hover: { backgroundColor: 'background.secondary' },
    '&[data-highlighted]': { backgroundColor: 'background.secondary' },
    '&[data-selected]': {
      backgroundColor: 'action.selected.brand',
      color: 'foreground.inverse',
    },
  },
});
